import './index.scss';
import React, { PropTypes }  from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import ourPropTypes from '../../../js/ourPropTypes';
import NotificationAction from '../NotificationAction';
import { clearNotification } from '../../../js/actions/notificationActionCreators';
import notificationSeverities from '../../../js/notification/notificationSeverities';
import classNames from 'classnames';

const TopNotificationBar = React.createClass({
    propTypes: {
        notification: ourPropTypes.notification,
        clearNotification: PropTypes.func.isRequired
    },
    render: function () {
        const { notification, clearNotification } = this.props;

        if(!notification) {return null;}

        const isError = notification.severity === notificationSeverities.error;
        const isInfo = notification.severity === notificationSeverities.info;
        const barClassNames = classNames('pure-u-1', 'top-notification-bar', 
            { 'top-notification-bar-error' : isError }, { 'top-notification-bar-info' : isInfo });
        const close = (e) => { clearNotification(notification); e.preventDefault(); };

        return (
            <div className={barClassNames}>
                <div>
                    <span className="notification-title">{notification.title}</span>
                    <span>{notification.message}</span>
                    {notification.actions.length > 0 && <span>|</span>}
                    {notification.actions.map(action =>
                        <NotificationAction key={action.name} action={action} dismiss={close}/>
                    )}
                    {notification.dismissable && <span className="notification-close">
                        <Link to="#" onClick={close}>X</Link>
                    </span>}
                </div>
            </div>
        );
    }
});

const mapStateToProps = (state) => {
    return {
        notification: state.app.notifications.top
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearNotification: (notification) => {
            dispatch(clearNotification(notification));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TopNotificationBar);



// WEBPACK FOOTER //
// ./src/components/common/TopNotificationBar/index.jsx